module.exports = __webpack_public_path__ + "static/media/appstore-1d1.34066d4a.png";